import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
export function ExitPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasShown, setHasShown] = useState(false);
  useEffect(() => {
    // Check if popup was already shown in this session
    const popupShown = sessionStorage.getItem('exitPopupShown');
    if (popupShown) {
      setHasShown(true);
      return;
    }
    let mobileTimer: NodeJS.Timeout;
    let lastScrollY = window.scrollY;
    // Desktop: Mouse leave detection
    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 0 && !hasShown && !isVisible) {
        showPopup();
      }
    };
    // Mobile: Timer (45 seconds)
    const startMobileTimer = () => {
      mobileTimer = setTimeout(() => {
        if (!hasShown && !isVisible) {
          showPopup();
        }
      }, 45000);
    };
    // Mobile: Rapid upward scroll detection
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const scrollDelta = lastScrollY - currentScrollY;
      // Detect rapid upward scroll (more than 100px up quickly)
      if (scrollDelta > 100 && !hasShown && !isVisible) {
        showPopup();
      }
      lastScrollY = currentScrollY;
    };
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      startMobileTimer();
      window.addEventListener('scroll', handleScroll);
    } else {
      document.addEventListener('mouseleave', handleMouseLeave);
    }
    return () => {
      if (isMobile) {
        clearTimeout(mobileTimer);
        window.removeEventListener('scroll', handleScroll);
      } else {
        document.removeEventListener('mouseleave', handleMouseLeave);
      }
    };
  }, [hasShown, isVisible]);
  const showPopup = () => {
    setIsVisible(true);
    setHasShown(true);
    sessionStorage.setItem('exitPopupShown', 'true');
    document.body.style.overflow = 'hidden';
  };
  const closePopup = () => {
    setIsVisible(false);
    document.body.style.overflow = 'auto';
  };
  // ESC key to close
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isVisible) {
        closePopup();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isVisible]);
  if (!isVisible) return null;
  return <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 px-4 animate-fadeIn" onClick={closePopup} data-id="element-175">
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-4xl w-full overflow-hidden flex flex-col md:flex-row animate-slideUp" onClick={e => e.stopPropagation()} data-id="element-176">
        {/* Close Button */}
        <button onClick={closePopup} className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors bg-white/90 rounded-full hover:bg-white" aria-label="Sluit popup" data-id="element-177">
          <XIcon className="w-6 h-6" data-id="element-178" />
        </button>

        {/* Image Column */}
        <div className="md:w-2/5 h-64 md:h-auto bg-gradient-to-br from-green-50 to-emerald-50 flex items-center justify-center p-6" data-id="element-179">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tzwmao2CV67Bvwhqs6phMi/c2adb125-10cb-4e9a-9138-62666ac51fdd.png" alt="Anifit Proefpakket voor honden" className="w-full h-full object-contain" data-id="element-180" />
        </div>

        {/* Content Column */}
        <div className="md:w-3/5 p-8 md:p-12 flex flex-col justify-center" data-id="element-181">
          <h2 className="text-2xl md:text-3xl font-bold text-[rgb(var(--color-neutral-900))] mb-4" data-id="element-182">
            Wacht! Voordat u gaat...
          </h2>

          <p className="text-base md:text-lg text-[rgb(var(--color-neutral-800))] leading-relaxed mb-6" data-id="element-183">
            Geef uw hond de kans op een gezonder en stressvrij leven. Omdat we
            geloven in deze eerste stap, bieden we u een exclusieve korting op
            het Anifit proefpakket.
          </p>

          {/* Discount Code Box */}
          <div className="bg-gradient-to-br from-green-50 to-emerald-50 border-2 border-dashed border-[rgb(var(--color-primary))] rounded-xl p-6 mb-6 text-center" data-id="element-184">
            <p className="text-sm font-semibold text-[rgb(var(--color-neutral-900))] mb-2" data-id="element-185">
              Gebruik code voor 10% korting:
            </p>
            <span className="inline-block text-2xl md:text-3xl font-bold text-[rgb(var(--color-primary))] tracking-wider bg-white px-6 py-2 rounded-lg" data-id="element-186">
              stresslessdogs
            </span>
          </div>

          {/* Primary CTA */}
          <a href="https://www.anifit.com/content/dierenvoeding/shop/shop/article/284379/proefpakket_hond_200g_1_set_met_verschillende_soorten_natvoer_vlokken_en_testpakketten_?new_client_country=NL&category=62183&refconsultant=487050&discount_code=stresslessdogs&utm_source=exitpopup&utm_medium=popup&utm_campaign=darmflora" target="_blank" rel="noopener noreferrer" className="block w-full bg-[rgb(var(--color-secondary))] hover:bg-orange-600 text-white text-center font-bold text-lg py-4 rounded-xl transition-all duration-300 hover:scale-105 shadow-lg mb-4" data-id="element-187">
            Ja, ik wil 10% korting!
          </a>

          {/* Secondary Link */}
          <button onClick={closePopup} className="text-sm text-gray-500 hover:text-gray-700 underline transition-colors" data-id="element-188">
            Nee, bedankt. Ik sla de korting over.
          </button>
        </div>
      </div>
    </div>;
}